import { initialiseCarousel } from './_helpers'
import { mediaBreakpoints } from '../utils'
import { getElement, getElements } from './../utils/functional'
import 'swiper/swiper.scss';


export default function init ({ el, context }) {
  const moduleClassName = el.dataset.moduleClassName
  const swiperContainer = el.getElementsByClassName(`${moduleClassName}_Carousel`)[0]
  const swiperNext = el.getElementsByClassName(`${moduleClassName}_Next`)[0]
  const swiperPrevious = el.getElementsByClassName(`${moduleClassName}_Previous`)[0]
  const swiperPaginationClass = `${moduleClassName}_Pagination`
  const swiperPaginationElement = el.getElementsByClassName(`${moduleClassName}_Pagination`)[0]

  
  const slideClass = `${moduleClassName}_Slide`
  var rowCount = parseInt(el.dataset.rowCount)

  const showNvaigation = swiperNext !== null && rowCount !== 4



  var navigation = false
  if(showNvaigation){
    navigation = {
      nextEl: swiperNext,
      prevEl: swiperPrevious,
      disabledClass: 'section__featured-products__swiper__navigation__disabled',
    }
  }

  window.addEventListener('resize', makeCarousel)
  
  makeCarousel();
   

  function makeCarousel () {
    
    var sliderPerViewCount = 3

    if(rowCount){
      sliderPerViewCount = parseInt(rowCount)
      var allowTouchMove = rowCount === 4 ? false : true
    }
    
    initialiseCarousel(
      swiperContainer,
      {
        watchSlidesProgress: true,
        centeredSlides: true,
        slideClass: slideClass,
        slidesPerView: 1.7,
        spaceBetween: 10,
        watchOverflow: true,
        breakpointsInverse: true,
        setWrapperSize: true,
        pagination: false,
        breakpoints: {
          769: {
            allowTouchMove: allowTouchMove,
            navigation: navigation,
            centeredSlides: false,
            loop: false,
            pagination: false,
            slidesPerView: sliderPerViewCount,
            spaceBetween: 5 * sliderPerViewCount
          }
        }
      }
    )
  }
}